import { AbilityBuilder, Ability } from '@casl/ability'
import { getUser } from '@/service/user'

const ability = new Ability()

export default function() {
  const { rules, can } = AbilityBuilder.extract()
  can('access', 'page.user-access')
  const userRules = getUser().rules || []

  userRules.map(([action, subject]) => can(action, subject))
  ability.update(rules)
  return ability
}
